export enum ElectricityProductionMethod {
  GRID = 'GRID',
  DIRECT_TECHNICAL_LINK = 'DIRECT_TECHNICAL_LINK',
  PPA = 'PPA'
}
